import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import md5 from 'md5';
import header from '../../assets/icm-header.jpg';
import icp from '../../assets/icp-brasil.png';
import {
  getBase64PDFImage,
  getBase64PDFImagePNG,
  prefixo,
} from '../../util/utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default async function generateReceitaPDF({
  receita,
  tipo = 'imprimirNormal',
  qrcodeBase64,
  assinaturaDigital,
  assinaturaEletronica,
  isDoctorLoggedIn,
}) {
  const texto = receita?.descricao ?? receita?.texto;
  const headerImage =
    tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
      ? await getBase64PDFImage(header)
      : null;
  // Converte o logo ICP para base64
  const icpLogoBase64 = await getBase64PDFImagePNG(icp);

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: headerImage ? [40, 130, 20, 130] : [40, 100, 20, 160],
    header: headerImage
      ? {
        image: headerImage,
        width: 500,
        alignment: 'center',
        margin: [0, 10, 0, 0],
      }
      : undefined,
    content: [
      {
        text:
          tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
            ? 'RECEITUÁRIO MÉDICO'
            : '',
        style: 'title',
        alignment: 'center',
        margin: [0, 20, 0, 20],
      },
      // Corpo da receita
      {
        text: texto ? texto : ' ',
        style: 'files',
        margin: [100, 30, 0, 30],
      },
    ],
    footer:
      isDoctorLoggedIn && assinaturaEletronica
        ? null
        : function footer(currentPage, pageCount) {
          // Define as colunas e larguras dinamicamente conforme a presença do ICP e QRCode
          const temIcp = Boolean(assinaturaDigital && icpLogoBase64);
          const temQrcode = Boolean(isDoctorLoggedIn && qrcodeBase64);

          // Monta as larguras das colunas
          const widths = [];
          if (temIcp) widths.push(80);
          widths.push('*'); // Coluna central para textos
          if (temQrcode) widths.push(80);

          // Monta as células da linha
          const rowCells = [];

          // 1. Célula ICP (se existir)
          if (temIcp) {
            rowCells.push({
              image: icpLogoBase64,
              width: 80,
              alignment: 'left',
              border: [false, false, false, false],
            });
          }

          // 2. Célula Central (Dados do Médico / Autenticação)
          rowCells.push({
            stack: [
              ...(isDoctorLoggedIn
                ? [
                  {
                    text: assinaturaDigital
                      ? 'Documento assinado digitalmente'
                      : 'Documento assinado eletronicamente',
                    alignment: 'center', // Alinha ao centro se tiver ICP, senão à esquerda
                    bold: true,
                    margin: [0, 0, 0, 0],
                    fontSize: 8,
                  },
                  {
                    text: `Autenticação: ${md5(
                      JSON.stringify(receita || '')
                    )}`,
                    alignment: 'center',
                    fontSize: 8,
                    margin: [0, 0, 0, 2],
                  },
                ]
                : []),

              {
                text: `Médico: ${prefixo(receita)} ${receita.nomeMedico || ''
                  }`,
                alignment: 'center',
                margin: [0, 0, 0, 0],
                fontSize: 10,
                bold: true,
              },
              {
                text: `CPF: ${receita.cpf || ''} - CRM: ${receita.crm || ''}${receita.rqe ? ' - RQE: ' + receita.rqe : ''
                  }`,
                alignment: 'center',
                margin: [0, 0, 0, 2],
                fontSize: 10,
                bold: true,
              },

              ...(isDoctorLoggedIn
                ? [
                  {
                    text: temQrcode
                      ? '* VALIDAÇÃO: Aponte a câmera do celular usando o QRCode ao lado *'
                      : '* VALIDAÇÃO: Verifique a autenticidade pelo código acima *',
                    alignment: 'center',
                    fontSize: 8,
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: `* Realizar a dispensação da RECEITA: ${receita.codReceita || ''
                      } - PACIENTE: ${receita.codPaciente || ''} *`,
                    alignment: 'center',
                    fontSize: 8,
                    margin: [0, 0, 0, 0],
                  },
                ]
                : []),
              {
                text: `Página ${currentPage} de ${pageCount}`,
                alignment: 'center',
                fontSize: 8,
                margin: [0, 0, 0, 0],
              },
            ],
            style: 'content',
            border: [false, false, false, false],
          });

          // 3. Célula QR Code (se existir)
          if (temQrcode) {
            rowCells.push({
              image: qrcodeBase64,
              width: 70,
              alignment: 'right',
              border: [false, false, false, false],
            });
          }

          return {
            margin: headerImage ? [40, 0, 40, 0] : [140, 0, 20, 0],
            stack: [
              {
                table: {
                  widths,
                  body: [rowCells],
                },
                layout: {
                  hLineWidth: () => 0,
                  vLineWidth: () => 0,
                },
              },
            ],
          };
        },
  };
  return pdfMake.createPdf(docDefinition);
}
